import React from 'react';
import { BodyTextRegularB } from '@/shared/ui/typography2';
import { StepBadge, StepHeader, OfferBlock, ItemList } from './styles';

export interface WelcomeOfferProps {
  stepNumber: number | null;
  title: string;
  items: string[];
  itemsType?: 'list' | 'text';
}

export const WelcomeOfferBlock: React.FC<WelcomeOfferProps> = ({ 
  stepNumber, 
  title, 
  items,
  itemsType = 'list' 
}) => {
  
  return (
    <OfferBlock>
      <StepHeader>
        {stepNumber && <StepBadge>{stepNumber}</StepBadge>}
        <BodyTextRegularB style={{ fontWeight: 700 }}>{title}</BodyTextRegularB>
      </StepHeader>

      {itemsType === 'text' ? (
          <BodyTextRegularB color='#AFAFAF'>{items}</BodyTextRegularB>
      ) : (
        <ItemList>
          {items?.map((item, index) => (
            <li key={index}>
              <BodyTextRegularB color='#AFAFAF'>{item}</BodyTextRegularB>
            </li>
          ))}
        </ItemList>
      )}
    </OfferBlock>
  );
};